import React, { useEffect, useState } from 'react';
import { Popover, OverlayTrigger, Table } from "react-bootstrap";

import CustomModal from "../../components/Modal/CustomModal";
import DatosInscripcion from "../Inscripcion/DatosInscripcion";

const EstudiantesTableC = (props) => {
    const [botonM, setBotonM] = useState({ icon: "fa fa-gear", text: "Acciones" });
    const [openMaterias, setOpenMaterias] = useState(false);

    const styles = {
        padding: 5, fontSize: 12
    }

    let nombre2 = props.data.nombre_2;
    let apellido2 = props.data.apellido_2;
    if (nombre2 === null) nombre2 = "";
    if (apellido2 === null) apellido2 = "";
    let nombreCompleto = `${props.data.nombre_1} ${nombre2} ${props.data.apellido_1} ${apellido2}`

    let contenido = () => {
        return (
            <Popover bsSize="large" id="Ins">
                <div className="text-success" onClick = {() => {setOpenMaterias(true)}} style={{padding: 5, fontSize: 12, cursor: "pointer"}}><i className="fa fa-address-book"></i> Ver Materias Inscritas</div>
            </Popover>
        )
    }

    /* Modales */
    let modalInscripcion = () => {

        let contenidoI = () => (
            <DatosInscripcion idEst={props.data.id_estudiante }
            tlf = {props.data.tlf_hab} cel = {props.data.tlf_cel}
            email = {props.data.email}
            EstCuenta ={false}/>
        )

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-check"></i> Aceptar</React.Fragment>}
                boton1 = ""
                large = "large"
                isopen =  {openMaterias}
                titulo = {<div className="text-danger" style={{fontSize: 14}}>{`Materias Inscritas de ${nombreCompleto}`}</div>}
                contenido = {contenidoI()}
                funcion2 = {() => {setOpenMaterias(false)}}
            />
        );
    }
    /* ------------------- */

    return (
        <tr>
            <td align="center" style={styles}>{`${props.data.nacionalidad} ${props.data.ci}`}</td>
            <td style={styles}>{nombreCompleto}</td>
            <td align="center" style={styles}>{props.data.carrera_name}</td>
            <td align="center" style={styles}>
                <OverlayTrigger trigger="focus" placement="right" overlay={contenido()}>
                    <button style={{borderWidth: 1}} className="btn btn-primary"><i className={botonM.icon}></i> {botonM.text}</button>
                </OverlayTrigger>
            </td>
            {modalInscripcion()}
        </tr>
    )
}

export default EstudiantesTableC;


// WEBPACK FOOTER //
// ./src/views/Consultas/EstudiantesTableC.jsx